import { useState } from "react";
import { Alert, Card, Space } from "antd";
import { useTranslate } from "@refinedev/core";
import { useDataExports } from "../hooks/useDataExports";
import { useActiveExport } from "../hooks/useActiveExport";
import { TriggerCard } from "./data-export/TriggerCard";
import { ExportInProgressCard } from "./data-export/ExportInProgressCard";
import { HistoryTable } from "./data-export/HistoryTable";
import type { BundleResponse } from "@/types";

export const DataExportTab = () => {
  const t = useTranslate();
  const { bundles, isLoading, triggerExport } = useDataExports();
  const { activeBundle } = useActiveExport();
  const [conflictMessage, setConflictMessage] = useState<string | null>(null);

  const handleAlreadyInProgress = () => {
    setConflictMessage(t("media.organizations.dataExport.alreadyInProgress"));
  };

  const handleReExport = async (bundle: BundleResponse) => {
    setConflictMessage(null);
    const result = await triggerExport({
      date_from: bundle.date_from ?? null,
      date_to: bundle.date_to ?? null,
    });
    if (result.alreadyInProgress) {
      handleAlreadyInProgress();
    }
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      {conflictMessage && (
        <Alert
          type="warning"
          showIcon
          message={conflictMessage}
          closable
          onClose={() => setConflictMessage(null)}
        />
      )}
      <Card>
        {activeBundle ? (
          <ExportInProgressCard bundle={activeBundle} />
        ) : (
          <TriggerCard onAlreadyInProgress={handleAlreadyInProgress} />
        )}
      </Card>
      <HistoryTable
        bundles={bundles}
        isLoading={isLoading}
        onReExport={(bundle) => {
          handleReExport(bundle).catch((error) => {
            console.error("Error re-exporting data export", error);
          });
        }}
      />
    </Space>
  );
};

export default DataExportTab;
